import { Brand } from "./brand.js";
import { Item, Term } from "./item.js";

export class ApiData {
  public sec = "";
  public star = "?";
  public name = "";
  public brand = "";
  public term = "";
  public id = "";
  public url = "";
  public point = "?";
  public check = false;
  public qr = "";
  public setQR = "";
  public bLoading = true;
  public bError = false;

  constructor(data?: any) {
    this.id = data.id ?? "";
    this.name = data.name ?? "";
    this.url = data.url ?? "";
    this.sec = data.sec ?? "";
    this.star = data.star === 0 ? "?" : data.star;
    // 三つ目のベがひらがなになってる場合がある
    if (data.brand === "ベアベアべア") data.brand = "ベアベアベア";
    this.brand = data.brand ?? "";
    this.term = data.term ?? "";
    this.point = data.point === 0 ? "?" : data.point;
    this.check = data.check ?? false;
    this.qr = data.qr ?? "";
    this.setQR = data.setQR ?? "";

    if (!this.checkData()) {
      this.bError = true;
    }

    this.bLoading = false;
  }

  public checkData(): boolean {
    if (!this.id || !this.name) {
      return false;
    }
    return true;
  }

  public convertToItem(): Item {
    const item: Partial<Item> = {};

    if (this.id) item.id = this.id;
    if (this.name) item.name = this.name;
    if (typeof this.check !== "undefined") item.check = this.check;
    if (this.sec) item.sec = this.sec;
    if (this.star) item.star = this.star;
    if (this.brand) item.brand = this.brand as Brand;
    if (this.term) item.term = this.term as Term;
    if (this.qr) item.qr = this.qr;
    if (this.setQR) item.setQR = this.setQR;
    if (this.point) item.point = this.point;
    if (this.url) item.url = this.url;

    // itemID, parentID, element は ApiData に存在しないので設定しない

    return item as Item;
  }

  public static initByArray(dataArray: any[]): ApiData[] {
    return dataArray.map((data) => new ApiData(data));
  }

  public static hasErrors(dataArray: ApiData[]): boolean {
    return dataArray.some((data) => data.bError);
  }
}
